export const countrtOptions = [
  {
    name: '_countryOptionList',
    key: '20',
    status: true,
    value: 'Andorra',
    label: 'ANDORRA'
  },
  {
    name: '_countryOptionList',
    key: '784',
    status: true,
    value: 'United Arab Emirates',
    label: 'UNITED ARAB EMIRATES'
  },
  {
    name: '_countryOptionList',
    key: '4',
    status: true,
    value: 'Afghanistan',
    label: 'AFGHANISTAN'
  },
  {
    name: '_countryOptionList',
    key: '28',
    status: true,
    value: 'Antigua and Barbuda',
    label: 'ANTIGUA AND BARBUDA'
  },
  {
    name: '_countryOptionList',
    key: '660',
    status: true,
    value: 'Anguilla',
    label: 'ANGUILLA'
  },
  {
    name: '_countryOptionList',
    key: '8',
    status: true,
    value: 'Albania',
    label: 'ALBANIA'
  },
  {
    name: '_countryOptionList',
    key: '51',
    status: true,
    value: 'Armenia',
    label: 'ARMENIA'
  },
  {
    name: '_countryOptionList',
    key: '24',
    status: true,
    value: 'Angola',
    label: 'ANGOLA'
  },
  {
    name: '_countryOptionList',
    key: '10',
    status: true,
    value: 'Antarctica',
    label: 'ANTARCTICA'
  },
  {
    name: '_countryOptionList',
    key: '32',
    status: true,
    value: 'Argentina',
    label: 'ARGENTINA'
  },
  {
    name: '_countryOptionList',
    key: '16',
    status: true,
    value: 'American Samoa',
    label: 'AMERICAN SAMOA'
  },
  {
    name: '_countryOptionList',
    key: '40',
    status: true,
    value: 'Austria',
    label: 'AUSTRIA'
  },
  {
    name: '_countryOptionList',
    key: '36',
    status: true,
    value: 'Australia',
    label: 'AUSTRALIA'
  },
  {
    name: '_countryOptionList',
    key: '533',
    status: true,
    value: 'Aruba',
    label: 'ARUBA'
  },
  {
    name: '_countryOptionList',
    key: '248',
    status: true,
    value: 'aland Island',
    label: 'ALAND ISLAND'
  },
  {
    name: '_countryOptionList',
    key: '31',
    status: true,
    value: 'Azerbaijan',
    label: 'AZERBAIJAN'
  },
  {
    name: '_countryOptionList',
    key: '70',
    status: true,
    value: 'Bosnia and Herzegovina',
    label: 'BOSNIA AND HERZEGOVINA'
  },
  {
    name: '_countryOptionList',
    key: '52',
    status: true,
    value: 'Barbados',
    label: 'BARBADOS'
  },
  {
    name: '_countryOptionList',
    key: '50',
    status: true,
    value: 'Bangladesh',
    label: 'BANGLADESH'
  },
  {
    name: '_countryOptionList',
    key: '56',
    status: true,
    value: 'Belgium',
    label: 'BELGIUM'
  },
  {
    name: '_countryOptionList',
    key: '854',
    status: true,
    value: 'Burkina',
    label: 'BURKINA'
  },
  {
    name: '_countryOptionList',
    key: '100',
    status: true,
    value: 'Bulgaria',
    label: 'BULGARIA'
  },
  {
    name: '_countryOptionList',
    key: '48',
    status: true,
    value: 'Bahrain',
    label: 'BAHRAIN'
  },
  {
    name: '_countryOptionList',
    key: '108',
    status: true,
    value: 'Burundi',
    label: 'BURUNDI'
  },
  {
    name: '_countryOptionList',
    key: '204',
    status: true,
    value: 'Benin',
    label: 'BENIN'
  },
  {
    name: '_countryOptionList',
    key: '652',
    status: true,
    value: 'Saint Barthélemy',
    label: 'SAINT BARTHÉLEMY'
  },
  {
    name: '_countryOptionList',
    key: '60',
    status: true,
    value: 'Bermuda',
    label: 'BERMUDA'
  },
  {
    name: '_countryOptionList',
    key: '96',
    status: true,
    value: 'Brunei',
    label: 'BRUNEI DARUSSALAM'
  },
  {
    name: '_countryOptionList',
    key: '68',
    status: true,
    value: 'Bolivia',
    label: 'BOLIVIA'
  },
  {
    name: '_countryOptionList',
    key: '535',
    status: true,
    value: 'Caribbean Netherlands',
    label: 'CARIBBEAN NETHERLANDS'
  },
  {
    name: '_countryOptionList',
    key: '76',
    status: true,
    value: 'Brazil',
    label: 'BRAZIL'
  },
  {
    name: '_countryOptionList',
    key: '44',
    status: true,
    value: 'The Bahamas',
    label: 'THE BAHAMAS'
  },
  {
    name: '_countryOptionList',
    key: '64',
    status: true,
    value: 'Bhutan',
    label: 'BHUTAN'
  },
  {
    name: '_countryOptionList',
    key: '74',
    status: true,
    value: 'Bouvet Island',
    label: 'BOUVET ISLAND'
  },
  {
    name: '_countryOptionList',
    key: '72',
    status: true,
    value: 'Botswana',
    label: 'BOTSWANA'
  },
  {
    name: '_countryOptionList',
    key: '112',
    status: true,
    value: 'Belarus',
    label: 'BELARUS'
  },
  {
    name: '_countryOptionList',
    key: '84',
    status: true,
    value: 'Belize',
    label: 'BELIZE'
  },
  {
    name: '_countryOptionList',
    key: '124',
    status: true,
    value: 'Canada',
    label: 'CANADA'
  },
  {
    name: '_countryOptionList',
    key: '166',
    status: true,
    value: 'Cocos (Keeling) Islands',
    label: 'COCOS (KEELING) ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '140',
    status: true,
    value: 'Central African Republic',
    label: 'CENTRAL AFRICAN REPUBLIC'
  },
  {
    name: '_countryOptionList',
    key: '756',
    status: true,
    value: 'Switzerland',
    label: 'SWITZERLAND'
  },
  {
    name: '_countryOptionList',
    key: '152',
    status: true,
    value: 'Chile',
    label: 'CHILE'
  },
  {
    name: '_countryOptionList',
    key: '120',
    status: true,
    value: 'Cameroon',
    label: 'CAMEROON'
  },
  {
    name: '_countryOptionList',
    key: '170',
    status: true,
    value: 'Colombia',
    label: 'COLOMBIA'
  },
  {
    name: '_countryOptionList',
    key: '188',
    status: true,
    value: 'Costa Rica',
    label: 'COSTA RICA'
  },
  {
    name: '_countryOptionList',
    key: '192',
    status: true,
    value: 'Cuba',
    label: 'CUBA'
  },
  {
    name: '_countryOptionList',
    key: '132',
    status: true,
    value: 'Cape Verde',
    label: 'CABO VERDE'
  },
  {
    name: '_countryOptionList',
    key: '162',
    status: true,
    value: 'Christmas Island',
    label: 'CHRISTMAS ISLAND'
  },
  {
    name: '_countryOptionList',
    key: '196',
    status: true,
    value: 'Cyprus',
    label: 'CYPRUS'
  },
  {
    name: '_countryOptionList',
    key: '203',
    status: true,
    value: 'Czech Republic',
    label: 'CZECH REPUBLIC'
  },
  {
    name: '_countryOptionList',
    key: '276',
    status: true,
    value: 'Germany',
    label: 'GERMANY'
  },
  {
    name: '_countryOptionList',
    key: '262',
    status: true,
    value: 'Djibouti',
    label: 'DJIBOUTI'
  },
  {
    name: '_countryOptionList',
    key: '208',
    status: true,
    value: 'Denmark',
    label: 'DENMARK'
  },
  {
    name: '_countryOptionList',
    key: '212',
    status: true,
    value: 'Dominica',
    label: 'DOMINICA'
  },
  {
    name: '_countryOptionList',
    key: '214',
    status: true,
    value: 'Dominican Republic',
    label: 'DOMINICAN REPUBLIC'
  },
  {
    name: '_countryOptionList',
    key: '12',
    status: true,
    value: 'Algeria',
    label: 'ALGERIA'
  },
  {
    name: '_countryOptionList',
    key: '218',
    status: true,
    value: 'Ecuador',
    label: 'ECUADOR'
  },
  {
    name: '_countryOptionList',
    key: '233',
    status: true,
    value: 'Estonia',
    label: 'ESTONIA'
  },
  {
    name: '_countryOptionList',
    key: '818',
    status: true,
    value: 'Egypt',
    label: 'EGYPT'
  },
  {
    name: '_countryOptionList',
    key: '732',
    status: true,
    value: 'Western Sahara',
    label: 'WESTERN SAHARA'
  },
  {
    name: '_countryOptionList',
    key: '232',
    status: true,
    value: 'Eritrea',
    label: 'ERITREA'
  },
  {
    name: '_countryOptionList',
    key: '724',
    status: true,
    value: 'Spain',
    label: 'SPAIN'
  },
  {
    name: '_countryOptionList',
    key: '246',
    status: true,
    value: 'Finland',
    label: 'FINLAND'
  },
  {
    name: '_countryOptionList',
    key: '242',
    status: true,
    value: 'Fiji',
    label: 'FIJI'
  },
  {
    name: '_countryOptionList',
    key: '238',
    status: true,
    value: 'Falkland Islands',
    label: 'FALKLAND ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '583',
    status: true,
    value: 'Federated States of Micronesia',
    label: 'FEDERATED STATES OF MICRONESIA'
  },
  {
    name: '_countryOptionList',
    key: '234',
    status: true,
    value: 'Faroe Islands',
    label: 'FAROE ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '250',
    status: true,
    value: 'France',
    label: 'FRANCE'
  },
  {
    name: '_countryOptionList',
    key: '266',
    status: true,
    value: 'Gabon',
    label: 'GABON'
  },
  {
    name: '_countryOptionList',
    key: '308',
    status: true,
    value: 'Grenada',
    label: 'GRENADA'
  },
  {
    name: '_countryOptionList',
    key: '268',
    status: true,
    value: 'Georgia',
    label: 'GEORGIA'
  },
  {
    name: '_countryOptionList',
    key: '254',
    status: true,
    value: 'French Guiana',
    label: 'FRENCH GUIANA'
  },
  {
    name: '_countryOptionList',
    key: '288',
    status: true,
    value: 'Ghana',
    label: 'GHANA'
  },
  {
    name: '_countryOptionList',
    key: '292',
    status: true,
    value: 'Gibraltar',
    label: 'GIBRALTAR'
  },
  {
    name: '_countryOptionList',
    key: '304',
    status: true,
    value: 'Greenland',
    label: 'GREENLAND'
  },
  {
    name: '_countryOptionList',
    key: '324',
    status: true,
    value: 'Guinea',
    label: 'GUINEA'
  },
  {
    name: '_countryOptionList',
    key: '312',
    status: true,
    value: 'Guadeloupe',
    label: 'GUADELOUPE'
  },
  {
    name: '_countryOptionList',
    key: '226',
    status: true,
    value: 'Equatorial Guinea',
    label: 'EQUATORIAL GUINEA'
  },
  {
    name: '_countryOptionList',
    key: '300',
    status: true,
    value: 'Greece',
    label: 'GREECE'
  },
  {
    name: '_countryOptionList',
    key: '239',
    status: true,
    value: 'South Georgia and the South Sandwich Islands',
    label: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '320',
    status: true,
    value: 'Guatemala',
    label: 'GUATEMALA'
  },
  {
    name: '_countryOptionList',
    key: '316',
    status: true,
    value: 'Guam',
    label: 'GUAM'
  },
  {
    name: '_countryOptionList',
    key: '624',
    status: true,
    value: 'Guinea-Bissau',
    label: 'GUINEA-BISSAU'
  },
  {
    name: '_countryOptionList',
    key: '328',
    status: true,
    value: 'Guyana',
    label: 'GUYANA'
  },
  {
    name: '_countryOptionList',
    key: '344',
    status: true,
    value: 'China Hong Kong',
    label: 'CHINA HONG KONG'
  },
  {
    name: '_countryOptionList',
    key: '334',
    status: true,
    value: 'Heard Island and McDonald Islands',
    label: 'HEARD ISLAND AND MCDONALD ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '340',
    status: true,
    value: 'Honduras',
    label: 'HONDURAS'
  },
  {
    name: '_countryOptionList',
    key: '191',
    status: true,
    value: 'Croatia',
    label: 'CROATIA'
  },
  {
    name: '_countryOptionList',
    key: '332',
    status: true,
    value: 'Haiti',
    label: 'HAITI'
  },
  {
    name: '_countryOptionList',
    key: '348',
    status: true,
    value: 'Hungary',
    label: 'HUNGARY'
  },
  {
    name: '_countryOptionList',
    key: '360',
    status: true,
    value: 'Indonesia',
    label: 'INDONESIA'
  },
  {
    name: '_countryOptionList',
    key: '372',
    status: true,
    value: 'Ireland',
    label: 'IRELAND'
  },
  {
    name: '_countryOptionList',
    key: '376',
    status: true,
    value: 'Israel',
    label: 'ISRAEL'
  },
  {
    name: '_countryOptionList',
    key: '833',
    status: true,
    value: 'Isle of Man',
    label: 'ISLE OF MAN'
  },
  {
    name: '_countryOptionList',
    key: '356',
    status: true,
    value: 'India',
    label: 'INDIA'
  },
  {
    name: '_countryOptionList',
    key: '86',
    status: true,
    value: 'British Indian Ocean Territory',
    label: 'BRITISH INDIAN OCEAN TERRITORY'
  },
  {
    name: '_countryOptionList',
    key: '368',
    status: true,
    value: 'Iraq',
    label: 'IRAQ'
  },
  {
    name: '_countryOptionList',
    key: '364',
    status: true,
    value: 'Iran',
    label: 'IRAN'
  },
  {
    name: '_countryOptionList',
    key: '352',
    status: true,
    value: 'Iceland',
    label: 'ICELAND'
  },
  {
    name: '_countryOptionList',
    key: '380',
    status: true,
    value: 'Italy',
    label: 'ITALY'
  },
  {
    name: '_countryOptionList',
    key: '832',
    status: true,
    value: 'Jersey',
    label: 'JERSEY'
  },
  {
    name: '_countryOptionList',
    key: '388',
    status: true,
    value: 'Jamaica',
    label: 'JAMAICA'
  },
  {
    name: '_countryOptionList',
    key: '400',
    status: true,
    value: 'Jordan',
    label: 'JORDAN'
  },
  {
    name: '_countryOptionList',
    key: '392',
    status: true,
    value: 'Japan',
    label: 'JAPAN'
  },
  {
    name: '_countryOptionList',
    key: '116',
    status: true,
    value: 'Cambodia',
    label: 'CAMBODIA'
  },
  {
    name: '_countryOptionList',
    key: '296',
    status: true,
    value: 'Kiribati',
    label: 'KIRIBATI'
  },
  {
    name: '_countryOptionList',
    key: '174',
    status: true,
    value: 'The Comoros',
    label: 'THE COMOROS'
  },
  {
    name: '_countryOptionList',
    key: '414',
    status: true,
    value: 'Kuwait',
    label: 'KUWAIT'
  },
  {
    name: '_countryOptionList',
    key: '136',
    status: true,
    value: 'Cayman Islands',
    label: 'CAYMAN ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '422',
    status: true,
    value: 'Lebanon',
    label: 'LEBANON'
  },
  {
    name: '_countryOptionList',
    key: '438',
    status: true,
    value: 'Liechtenstein',
    label: 'LIECHTENSTEIN'
  },
  {
    name: '_countryOptionList',
    key: '144',
    status: true,
    value: 'Sri Lanka',
    label: 'SRI LANKA'
  },
  {
    name: '_countryOptionList',
    key: '430',
    status: true,
    value: 'Liberia',
    label: 'LIBERIA'
  },
  {
    name: '_countryOptionList',
    key: '426',
    status: true,
    value: 'Lesotho',
    label: 'LESOTHO'
  },
  {
    name: '_countryOptionList',
    key: '440',
    status: true,
    value: 'Lithuania',
    label: 'LITHUANIA'
  },
  {
    name: '_countryOptionList',
    key: '442',
    status: true,
    value: 'Luxembourg',
    label: 'LUXEMBOURG'
  },
  {
    name: '_countryOptionList',
    key: '428',
    status: true,
    value: 'Latvia',
    label: 'LATVIA'
  },
  {
    name: '_countryOptionList',
    key: '434',
    status: true,
    value: 'Libya',
    label: 'LIBYA'
  },
  {
    name: '_countryOptionList',
    key: '504',
    status: true,
    value: 'Morocco',
    label: 'MOROCCO'
  },
  {
    name: '_countryOptionList',
    key: '492',
    status: true,
    value: 'Monaco',
    label: 'MONACO'
  },
  {
    name: '_countryOptionList',
    key: '498',
    status: true,
    value: 'Moldova',
    label: 'MOLDOVA'
  },
  {
    name: '_countryOptionList',
    key: '499',
    status: true,
    value: 'Montenegro',
    label: 'MONTENEGRO'
  },
  {
    name: '_countryOptionList',
    key: '663',
    status: true,
    value: 'Saint Martin (France)',
    label: 'SAINT MARTIN (FRANCE)'
  },
  {
    name: '_countryOptionList',
    key: '450',
    status: true,
    value: 'Madagascar',
    label: 'MADAGASCAR'
  },
  {
    name: '_countryOptionList',
    key: '584',
    status: true,
    value: 'Marshall islands',
    label: 'MARSHALL ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '807',
    status: true,
    value: 'Republic of Macedonia (FYROM)',
    label: 'REPUBLIC OF MACEDONIA (FYROM)'
  },
  {
    name: '_countryOptionList',
    key: '466',
    status: true,
    value: 'Mali',
    label: 'MALI'
  },
  {
    name: '_countryOptionList',
    key: '104',
    status: true,
    value: 'Myanmar (Burma)',
    label: 'MYANMAR (BURMA)'
  },
  {
    name: '_countryOptionList',
    key: '446',
    status: true,
    value: 'China Macao',
    label: 'CHINA MACAO'
  },
  {
    name: '_countryOptionList',
    key: '474',
    status: true,
    value: 'Martinique',
    label: 'MARTINIQUE'
  },
  {
    name: '_countryOptionList',
    key: '478',
    status: true,
    value: 'Mauritania',
    label: 'MAURITANIA'
  },
  {
    name: '_countryOptionList',
    key: '500',
    status: true,
    value: 'Montserrat',
    label: 'MONTSERRAT'
  },
  {
    name: '_countryOptionList',
    key: '470',
    status: true,
    value: 'Malta',
    label: 'MALTA'
  },
  {
    name: '_countryOptionList',
    key: '462',
    status: true,
    value: 'Maldives',
    label: 'MALDIVES'
  },
  {
    name: '_countryOptionList',
    key: '454',
    status: true,
    value: 'Malawi',
    label: 'MALAWI'
  },
  {
    name: '_countryOptionList',
    key: '484',
    status: true,
    value: 'Mexico',
    label: 'MEXICO'
  },
  {
    name: '_countryOptionList',
    key: '458',
    status: true,
    value: 'Malaysia',
    label: 'MALAYSIA'
  },
  {
    name: '_countryOptionList',
    key: '516',
    status: true,
    value: 'Namibia',
    label: 'NAMIBIA'
  },
  {
    name: '_countryOptionList',
    key: '562',
    status: true,
    value: 'Niger',
    label: 'NIGER'
  },
  {
    name: '_countryOptionList',
    key: '574',
    status: true,
    value: 'Norfolk Island',
    label: 'NORFOLK ISLAND'
  },
  {
    name: '_countryOptionList',
    key: '566',
    status: true,
    value: 'Nigeria',
    label: 'NIGERIA'
  },
  {
    name: '_countryOptionList',
    key: '558',
    status: true,
    value: 'Nicaragua',
    label: 'NICARAGUA'
  },
  {
    name: '_countryOptionList',
    key: '528',
    status: true,
    value: 'Netherlands',
    label: 'NETHERLANDS'
  },
  {
    name: '_countryOptionList',
    key: '578',
    status: true,
    value: 'Norway',
    label: 'NORWAY'
  },
  {
    name: '_countryOptionList',
    key: '524',
    status: true,
    value: 'Nepal',
    label: 'NEPAL'
  },
  {
    name: '_countryOptionList',
    key: '520',
    status: true,
    value: 'Nauru',
    label: 'NAURU'
  },
  {
    name: '_countryOptionList',
    key: '512',
    status: true,
    value: 'Oman',
    label: 'OMAN'
  },
  {
    name: '_countryOptionList',
    key: '591',
    status: true,
    value: 'Panama',
    label: 'PANAMA'
  },
  {
    name: '_countryOptionList',
    key: '604',
    status: true,
    value: 'Peru',
    label: 'PERU'
  },
  {
    name: '_countryOptionList',
    key: '258',
    status: true,
    value: 'French polynesia',
    label: 'FRENCH POLYNESIA'
  },
  {
    name: '_countryOptionList',
    key: '598',
    status: true,
    value: 'Papua New Guinea',
    label: 'PAPUA NEW GUINEA'
  },
  {
    name: '_countryOptionList',
    key: '608',
    status: true,
    value: 'The Philippines',
    label: 'THE PHILIPPINES'
  },
  {
    name: '_countryOptionList',
    key: '586',
    status: true,
    value: 'Pakistan',
    label: 'PAKISTAN'
  },
  {
    name: '_countryOptionList',
    key: '616',
    status: true,
    value: 'Poland',
    label: 'POLAND'
  },
  {
    name: '_countryOptionList',
    key: '612',
    status: true,
    value: 'Pitcairn Islands',
    label: 'PITCAIRN ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '630',
    status: true,
    value: 'Puerto Rico',
    label: 'PUERTO RICO'
  },
  {
    name: '_countryOptionList',
    key: '275',
    status: true,
    value: 'Palestinian territories',
    label: 'PALESTINIAN TERRITORIES'
  },
  {
    name: '_countryOptionList',
    key: '585',
    status: true,
    value: 'Palau',
    label: 'PALAU'
  },
  {
    name: '_countryOptionList',
    key: '600',
    status: true,
    value: 'Paraguay',
    label: 'PARAGUAY'
  },
  {
    name: '_countryOptionList',
    key: '634',
    status: true,
    value: 'Qatar',
    label: 'QATAR'
  },
  {
    name: '_countryOptionList',
    key: '638',
    status: true,
    value: 'Réunion',
    label: 'RÉUNION'
  },
  {
    name: '_countryOptionList',
    key: '642',
    status: true,
    value: 'Romania',
    label: 'ROMANIA'
  },
  {
    name: '_countryOptionList',
    key: '688',
    status: true,
    value: 'Serbia',
    label: 'SERBIA'
  },
  {
    name: '_countryOptionList',
    key: '643',
    status: true,
    value: 'Russian Federation',
    label: 'RUSSIAN FEDERATION'
  },
  {
    name: '_countryOptionList',
    key: '646',
    status: true,
    value: 'Rwanda',
    label: 'RWANDA'
  },
  {
    name: '_countryOptionList',
    key: '90',
    status: true,
    value: 'Solomon Islands',
    label: 'SOLOMON ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '690',
    status: true,
    value: 'Seychelles',
    label: 'SEYCHELLES'
  },
  {
    name: '_countryOptionList',
    key: '729',
    status: true,
    value: 'Sudan',
    label: 'SUDAN'
  },
  {
    name: '_countryOptionList',
    key: '752',
    status: true,
    value: 'Sweden',
    label: 'SWEDEN'
  },
  {
    name: '_countryOptionList',
    key: '702',
    status: true,
    value: 'Singapore',
    label: 'SINGAPORE'
  },
  {
    name: '_countryOptionList',
    key: '705',
    status: true,
    value: 'Slovenia',
    label: 'SLOVENIA'
  },
  {
    name: '_countryOptionList',
    key: '744',
    status: true,
    value: 'Template:Country data SJM Svalbard',
    label: 'TEMPLATE:COUNTRY DATA SJM SVALBARD'
  },
  {
    name: '_countryOptionList',
    key: '703',
    status: true,
    value: 'Slovakia',
    label: 'SLOVAKIA'
  },
  {
    name: '_countryOptionList',
    key: '694',
    status: true,
    value: 'Sierra Leone',
    label: 'SIERRA LEONE'
  },
  {
    name: '_countryOptionList',
    key: '674',
    status: true,
    value: 'San Marino',
    label: 'SAN MARINO'
  },
  {
    name: '_countryOptionList',
    key: '686',
    status: true,
    value: 'Senegal',
    label: 'SENEGAL'
  },
  {
    name: '_countryOptionList',
    key: '706',
    status: true,
    value: 'Somalia',
    label: 'SOMALIA'
  },
  {
    name: '_countryOptionList',
    key: '740',
    status: true,
    value: 'Suriname',
    label: 'SURINAME'
  },
  {
    name: '_countryOptionList',
    key: '728',
    status: true,
    value: 'South Sudan',
    label: 'SOUTH SUDAN'
  },
  {
    name: '_countryOptionList',
    key: '678',
    status: true,
    value: 'Sao Tome and Principe',
    label: 'SAO TOME AND PRINCIPE'
  },
  {
    name: '_countryOptionList',
    key: '222',
    status: true,
    value: 'El Salvador',
    label: 'EL SALVADOR'
  },
  {
    name: '_countryOptionList',
    key: '760',
    status: true,
    value: 'Syria',
    label: 'SYRIA'
  },
  {
    name: '_countryOptionList',
    key: '748',
    status: true,
    value: 'Swaziland',
    label: 'SWAZILAND'
  },
  {
    name: '_countryOptionList',
    key: '796',
    status: true,
    value: 'Turks and Caicos Islands',
    label: 'TURKS AND CAICOS ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '148',
    status: true,
    value: 'Chad',
    label: 'CHAD'
  },
  {
    name: '_countryOptionList',
    key: '768',
    status: true,
    value: 'Togo',
    label: 'TOGO'
  },
  {
    name: '_countryOptionList',
    key: '764',
    status: true,
    value: 'Thailand',
    label: 'THAILAND'
  },
  {
    name: '_countryOptionList',
    key: '772',
    status: true,
    value: 'Tokelau',
    label: 'TOKELAU'
  },
  {
    name: '_countryOptionList',
    key: '626',
    status: true,
    value: 'Timor-Leste (East Timor)',
    label: 'TIMOR-LESTE (EAST TIMOR)'
  },
  {
    name: '_countryOptionList',
    key: '788',
    status: true,
    value: 'Tunisia',
    label: 'TUNISIA'
  },
  {
    name: '_countryOptionList',
    key: '776',
    status: true,
    value: 'Tonga',
    label: 'TONGA'
  },
  {
    name: '_countryOptionList',
    key: '792',
    status: true,
    value: 'Turkey',
    label: 'TURKEY'
  },
  {
    name: '_countryOptionList',
    key: '798',
    status: true,
    value: 'Tuvalu',
    label: 'TUVALU'
  },
  {
    name: '_countryOptionList',
    key: '834',
    status: true,
    value: 'Tanzania',
    label: 'TANZANIA'
  },
  {
    name: '_countryOptionList',
    key: '804',
    status: true,
    value: 'Ukraine',
    label: 'UKRAINE'
  },
  {
    name: '_countryOptionList',
    key: '800',
    status: true,
    value: 'Uganda',
    label: 'UGANDA'
  },
  {
    name: '_countryOptionList',
    key: '840',
    status: true,
    value: 'United States of America (USA)',
    label: 'UNITED STATES OF AMERICA (USA)'
  },
  {
    name: '_countryOptionList',
    key: '858',
    status: true,
    value: 'Uruguay',
    label: 'URUGUAY'
  },
  {
    name: '_countryOptionList',
    key: '336',
    status: true,
    value: 'Vatican City (The Holy See)',
    label: 'VATICAN CITY (THE HOLY SEE)'
  },
  {
    name: '_countryOptionList',
    key: '862',
    status: true,
    value: 'Venezuela',
    label: 'VENEZUELA'
  },
  {
    name: '_countryOptionList',
    key: '92',
    status: true,
    value: 'British Virgin Islands',
    label: 'BRITISH VIRGIN ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '850',
    status: true,
    value: 'United States Virgin Islands',
    label: 'UNITED STATES VIRGIN ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '704',
    status: true,
    value: 'Vietnam',
    label: 'VIETNAM'
  },
  {
    name: '_countryOptionList',
    key: '876',
    status: true,
    value: 'Wallis and Futuna',
    label: 'WALLIS AND FUTUNA'
  },
  {
    name: '_countryOptionList',
    key: '882',
    status: true,
    value: 'Samoa',
    label: 'SAMOA'
  },
  {
    name: '_countryOptionList',
    key: '887',
    status: true,
    value: 'Yemen',
    label: 'YEMEN'
  },
  {
    name: '_countryOptionList',
    key: '175',
    status: true,
    value: 'Mayotte',
    label: 'MAYOTTE'
  },
  {
    name: '_countryOptionList',
    key: '710',
    status: true,
    value: 'South Africa',
    label: 'SOUTH AFRICA'
  },
  {
    name: '_countryOptionList',
    key: '894',
    status: true,
    value: 'Zambia',
    label: 'ZAMBIA'
  },
  {
    name: '_countryOptionList',
    key: '716',
    status: true,
    value: 'Zimbabwe',
    label: 'ZIMBABWE'
  },
  {
    name: '_countryOptionList',
    key: '156',
    status: true,
    value: 'China',
    label: 'CHINA'
  },
  {
    name: '_countryOptionList',
    key: '178',
    status: true,
    value: 'Republic of the Congo',
    label: 'REPUBLIC OF THE CONGO'
  },
  {
    name: '_countryOptionList',
    key: '180',
    status: true,
    value: 'Democratic Republic of the Congo',
    label: 'DEMOCRATIC REPUBLIC OF THE CONGO'
  },
  {
    name: '_countryOptionList',
    key: '508',
    status: true,
    value: 'Mozambique',
    label: 'MOZAMBIQUE'
  },
  {
    name: '_countryOptionList',
    key: '831',
    status: true,
    value: 'Guernsey',
    label: 'GUERNSEY'
  },
  {
    name: '_countryOptionList',
    key: '270',
    status: true,
    value: 'Gambia',
    label: 'GAMBIA'
  },
  {
    name: '_countryOptionList',
    key: '580',
    status: true,
    value: 'Northern Mariana Islands',
    label: 'NORTHERN MARIANA ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '231',
    status: true,
    value: 'Ethiopia',
    label: 'ETHIOPIA'
  },
  {
    name: '_countryOptionList',
    key: '540',
    status: true,
    value: 'New Caledonia',
    label: 'NEW CALEDONIA'
  },
  {
    name: '_countryOptionList',
    key: '548',
    status: true,
    value: 'Vanuatu',
    label: 'VANUATU'
  },
  {
    name: '_countryOptionList',
    key: '260',
    status: true,
    value: 'French Southern Territories',
    label: 'FRENCH SOUTHERN TERRITORIES'
  },
  {
    name: '_countryOptionList',
    key: '570',
    status: true,
    value: 'Niue',
    label: 'NIUE'
  },
  {
    name: '_countryOptionList',
    key: '581',
    status: true,
    value: 'United States Minor Outlying Islands',
    label: 'UNITED STATES MINOR OUTLYING ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '184',
    status: true,
    value: 'Cook Islands',
    label: 'COOK ISLANDS'
  },
  {
    name: '_countryOptionList',
    key: '826',
    status: true,
    value: 'Great Britain (United Kingdom; England)',
    label: 'GREAT BRITAIN (UNITED KINGDOM; ENGLAND)'
  },
  {
    name: '_countryOptionList',
    key: '780',
    status: true,
    value: 'Trinidad and Tobago',
    label: 'TRINIDAD AND TOBAGO'
  },
  {
    name: '_countryOptionList',
    key: '670',
    status: true,
    value: 'St. Vincent and the Grenadines',
    label: 'ST. VINCENT AND THE GRENADINES'
  },
  {
    name: '_countryOptionList',
    key: '158',
    status: true,
    value: 'China Taiwan',
    label: 'CHINA TAIWAN'
  },
  {
    name: '_countryOptionList',
    key: '554',
    status: true,
    value: 'New Zealand',
    label: 'NEW ZEALAND'
  },
  {
    name: '_countryOptionList',
    key: '682',
    status: true,
    value: 'Saudi Arabia',
    label: 'SAUDI ARABIA'
  },
  {
    name: '_countryOptionList',
    key: '418',
    status: true,
    value: 'Laos',
    label: 'LAOS'
  },
  {
    name: '_countryOptionList',
    key: '408',
    status: true,
    value: 'North Korea',
    label: 'NORTH KOREA'
  },
  {
    name: '_countryOptionList',
    key: '410',
    status: true,
    value: 'South Korea',
    label: 'SOUTH KOREA'
  },
  {
    name: '_countryOptionList',
    key: '620',
    status: true,
    value: 'Portugal',
    label: 'PORTUGAL'
  },
  {
    name: '_countryOptionList',
    key: '417',
    status: true,
    value: 'Kyrgyzstan',
    label: 'KYRGYZSTAN'
  },
  {
    name: '_countryOptionList',
    key: '398',
    status: true,
    value: 'Kazakhstan',
    label: 'KAZAKHSTAN'
  },
  {
    name: '_countryOptionList',
    key: '762',
    status: true,
    value: 'Tajikistan',
    label: 'TAJIKISTAN'
  },
  {
    name: '_countryOptionList',
    key: '795',
    status: true,
    value: 'Turkmenistan',
    label: 'TURKMENISTAN'
  },
  {
    name: '_countryOptionList',
    key: '860',
    status: true,
    value: 'Uzbekistan',
    label: 'UZBEKISTAN'
  },
  {
    name: '_countryOptionList',
    key: '659',
    status: true,
    value: 'St. Kitts and Nevis',
    label: 'ST. KITTS AND NEVIS'
  },
  {
    name: '_countryOptionList',
    key: '666',
    status: true,
    value: 'Saint-Pierre and Miquelon',
    label: 'SAINT-PIERRE AND MIQUELON'
  },
  {
    name: '_countryOptionList',
    key: '654',
    status: true,
    value: 'St. Helena and Dependencies',
    label: 'ST. HELENA AND DEPENDENCIES'
  },
  {
    name: '_countryOptionList',
    key: '662',
    status: true,
    value: 'St. Lucia',
    label: 'ST. LUCIA'
  },
  {
    name: '_countryOptionList',
    key: '480',
    status: true,
    value: 'Mauritius',
    label: 'MAURITIUS'
  },
  {
    name: '_countryOptionList',
    key: '384',
    status: true,
    value: "Cote D'Ivoire",
    label: "COTE D'IVOIRE"
  },
  {
    name: '_countryOptionList',
    key: '404',
    status: true,
    value: 'Kenya',
    label: 'KENYA'
  },
  {
    name: '_countryOptionList',
    key: '496',
    status: true,
    value: 'Mongolia',
    label: 'MONGOLIA'
  },
  {
    name: '_countryOptionList',
    key: '000',
    status: true,
    value: 'OTHER',
    label: 'OTHER'
  }
]
